import Vue from "vue";
import Router from "vue-router";
import List from "../components/List";
import Home from "../components/Home";
import View from "../components/List/View";
import Hashtags from "../components/Hashtags";
import Search from "../components/Search";

Vue.use(Router);

export default new Router({
  mode: "history",
  linkActiveClass: "active",
  routes: [
    {
      path: "/",
      component: Home
    },
    {
      path: "/:slug",
      component: List
    },
    {
      path: "/v/:id",
      component: View
    },
    {
      path: "/hash/:slug",
      component: Hashtags
    },
    {
      path: "/search/:keyword",
      component: Search
    }
  ]
});
